export default {
  title: 'Documentele mele',
  description: 'Documentele de afaceri încărcate. Le poți descărca sau înlocui oricând.',
  document_types: {
    owner_document: 'Document de identitate al proprietarului',
    business_document: 'Document de afaceri',
  },
  kinds: {
    vat_registration: 'Înregistrare TVA',
    trade_registration: 'Înregistrare comercială',
    trade_license: 'Licență comercială',
    commercial_register_extract: 'Extras registru comercial',
    financial_statements: 'Situații financiare',
    bank_statement: 'Extras de cont',
    shareholder_list: 'Lista acționarilor',
    other: 'Altele',
    passport: 'Pașaport',
    driver_license: 'Permis de conducere',
    id_card: 'Carte de identitate',
    residence_permit: 'Permis de ședere',
  },
  sides: {
    front: 'Față',
    back: 'Spate',
  },
  fields: {
    slot: 'Categorie',
    document: 'Document',
    kind: 'Categorie',
    side: 'Parte',
    uploaded_at: 'Încărcat',
    expires_at: 'Expiră',
    retained_until: 'Păstrat până la',
    deleted_at: 'Șters',
    storage_deleted_at: 'Șters permanent',
    actions: 'Acțiuni',
  },
  values: {
    no_slot: 'Altele',
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filtrează după tip document',
    kind_placeholder: 'Filtrează după categorie',
  },
  retention: {
    deletable: 'Poate fi șters',
    tooltip:
      'Legea germană (GoBD / §147 AO) ne obligă să păstrăm acest document până la {{date}}. Poate fi șters numai după această dată.',
    tooltip_no_date: 'Acest document face obiectul unui termen legal de păstrare și nu poate fi șters încă.',
  },
  buttons: {
    upload: 'Încarcă',
    upload_other: 'Alt document',
    retry_slots: 'Documentele nu au putut fi încărcate — încearcă din nou',
    download: 'Descarcă',
    download_front: 'Descarcă față',
    download_back: 'Descarcă verso',
    reupload: 'Reîncarcă',
    delete: 'Șterge',
  },
  empty: 'Nu ați încărcat niciun document încă.',
  delete_modal: {
    title: 'Șterge document',
    description:
      'Alegeți cum să ștergeți acest document. „Șterge" îl arhivează și îl ascunde din listă. „Șterge definitiv" elimină fișierele ireversibil și este posibil doar după expirarea perioadei legale de păstrare.',
    delete: 'Șterge',
    permanently_delete: 'Șterge definitiv',
    cancel: 'Anulează',
    retention_alert:
      'Aceste documente fac obiectul unor termene legale de păstrare conform legislației germane (GoBD / §147 AO). Ștergerea definitivă a unui document elimină fișierele în mod ireversibil.',
  },
  reupload_modal: {
    title: 'Reîncarcă document',
    description: 'Încărcați o versiune nouă a acestui document. Versiunea anterioară va fi înlocuită.',
    type: {
      label: 'Tip document',
      placeholder: 'Selectați tipul documentului',
    },
    kind: {
      label: 'Categorie document',
      placeholder: 'Selectați categoria documentului',
    },
    front: {
      label: 'Față document',
    },
    back: {
      label: 'Verso document (opțional pentru unele documente)',
    },
    expires_at: {
      label: 'Data expirării documentului',
      placeholder: 'Selectați data expirării',
    },
    buttons: {
      select_file: 'Selectați fișierul',
      submit: 'Încarcă',
      cancel: 'Anulează',
    },
  },
  toasts: {
    download_error: 'Descărcarea documentului a eșuat.',
    delete_success: 'Documentul a fost șters cu succes.',
    delete_error: 'Ștergerea documentului a eșuat.',
    reupload_success: 'Documentul a fost încărcat cu succes.',
    reupload_error: 'Încărcarea documentului a eșuat.',
  },
};
